import mapboxgl from 'mapbox-gl';

mapboxgl.accessToken = ecConfig.mapboxToken;


/**
 * Large maps
 */

const containers = document.querySelectorAll('.map');

containers.forEach(container => {
    const locationContainer = container.querySelector('.map-locations');
    const closeButton = container.querySelector('.map-close');
    const canvas = container.querySelector('.map-canvas');
    
    let map;
    let locations = [];
    let markers = [];
    let bounds;
    let currentMarker;
    let currentCard;
    let center;

    if (container.dataset.center) {
        center = JSON.parse(container.dataset.center).map(parseFloat);
    } else {
        center = [5.12175, 52.09067]; // Default to Utrecht if no center is provided
    }
    
    function createMarkers() {
        locations = [...locationContainer.querySelectorAll('.map-location')];
        bounds = new mapboxgl.LngLatBounds();
        
        locations.forEach(location => {
            const lng = parseFloat(location.dataset.lng);
            const lat = parseFloat(location.dataset.lat);
            const marker = document.createElement('div');
            
            marker.className = 'map-marker';
            marker.dataset.id = location.dataset.id;
            marker.addEventListener('click', handleMarkerClick);

            markers.push(new mapboxgl.Marker(marker).setLngLat([lng, lat]).addTo(map));
            bounds.extend([lng, lat]);
        });
        
        resetZoom();
    }

    function removeMarkers() {
        markers.forEach(marker => marker.remove());
        markers = [];
    }

    function resetZoom() {
        if (locations.length > 1) {
            // map.fitBounds(bounds, { padding: { top: 250, bottom: 50, left: 100, right: 100 } });
            map.fitBounds(bounds, { padding: { top: 70, bottom: 70, left: 100, right: 100 } });
        } else {
            map.flyTo({ center: bounds.getCenter(), zoom: 14 });
        }
    }

    function activateLocation(locationId) {
        const targetMarker = markers.find(marker => marker.getElement().dataset.id == locationId);
        const targetCard = locationContainer.querySelector('.map-location[data-id="' + locationId + '"]');
    
        if (!targetMarker || !targetCard) {
            return;
        }
    
        currentMarker?.getElement().classList.remove('active');
        currentCard?.classList.remove('visible');
    
        locationContainer.classList.add('visible');
        targetMarker.getElement().classList.add('active');
        targetCard.classList.add('visible');
    
        currentMarker = targetMarker;
        currentCard = targetCard;
    }

    function deactivateLocation() {
        locationContainer.classList.remove('visible');
        currentMarker?.getElement().classList.remove('active');
        
        let tempCurrentCard = currentCard;
        locationContainer.addEventListener('transitionend', () => {
            tempCurrentCard?.classList.remove('visible');
        }, { once: true });
    
        currentMarker = currentCard = null;
    }
    
    function handleMarkerClick(e) {
        const marker = e.target;
        
        if (currentMarker?.getElement() === marker) {
            deactivateLocation();
        } else {
            activateLocation(marker.dataset.id);
        }
    }
    
    function handleLocationContainerClick(e) {
        const isCloseButton = e.target.classList.contains('.card-close') || e.target.closest('.card-close');
    
        if (!isCloseButton) {
            return;
        }
    
        e.stopPropagation();
        e.preventDefault();
    
        if (isCloseButton) {
            deactivateLocation();
        }
    }

    function expandMap() {
        if (!map) {
            createMap();
        }

        container.classList.add('expanded');
        map.resize();
        resetZoom();
        
        window.addEventListener('keyup', (e) => {
            if (e.key === 'Escape') {
                closeMap();
            }
        }, { once: true });
    }

    function closeMap() {
        container.classList.remove('expanded');
        map.resize();
        resetZoom();
    }

    function reloadLocations() {
        deactivateLocation();
        removeMarkers();
        createMarkers();
    }

    function createMap() {
        map = new mapboxgl.Map({
            container: canvas,
            center: center,
            zoom: 10,
        });
        
        document.addEventListener('locationsUpdated', reloadLocations);
        
        locationContainer.addEventListener('click', handleLocationContainerClick);
        closeButton.addEventListener('click', closeMap);
        
        createMarkers();
    }

    document.addEventListener('expandMap', expandMap);
});


/**
 * Map toggles
 */

window.addEventListener('click', e => {
    const isMapToggle = e.target.matches('[data-map-toggle]') || e.target.closest('[data-map-toggle]');
    
    if (!isMapToggle) {
        return;
    }

    document.dispatchEvent(new Event('expandMap'));
});